let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iI0JV")).then(() => parcelRequire('7c5Kl'));